import { IInTransitMapConfig } from '@fareye/intransit-map'
import environment from '../../environment'

const { baseURL } = environment

const InTransitMapPortRenderingConfig: IInTransitMapConfig = {
  config: {
    apiConfig: {
      url: '/api/v3/port_congestions/current_port_congestion',
      query: { 'location_code_list': [] }
    },
    filters: [
      {
        label: 'Search Ports',
        options: [],
        placeholder: 'Search Ports',
        value: null,
        key: 'locationCode',
        isMulti: true
      },
      {
        label: 'Search By Country',
        options: [],
        placeholder: 'Search By Country',
        value: null,
        key: 'locationCountry',
        isMulti: true
      }
    ]
  },
  children: {},
  styling: {
    layoutStyle: { height: 'calc(100vh - 50px)', background: '#fff' },
    style: {},
    className: '',
    variant: ''
  }
}
export default InTransitMapPortRenderingConfig
